module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_WEST_STYLE.e7deee11.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_WEST_STYLE.png
// module id = 1312
// module chunks = 16